import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Scroll-triggered fade + rise reveal used across sections.
export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal — each line rises from a clipped wrapper.
export function MaskedLines({ lines, className = "", lineClassName = "", start = false }) {
  return (
    <span className={`block ${className}`} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i} aria-hidden="true">
          <motion.span
            className={`block pb-[0.12em] ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={start ? { y: "0%" } : {}}
            transition={{ duration: 1, ease: EASE, delay: 0.25 + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
